import BackgroundSkylineLarge from "../../images/background/BackgroundSkylineLarge"
import "../../styles/components/map/SkylineLarge.scss";

export default function SkylineLarge() {
    return (
        <div className="SkylineLarge">
            <BackgroundSkylineLarge />
        </div>        
    )
}